import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { DragonfliesLoader } from "./dragonflies-loader";

interface LoadingProps {
  text?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
  color?: string;
  showSpinner?: boolean;
  variant?: "default" | "dragonfly";
}

export function Loading({
  text,
  size = "md",
  className,
  color = "#000000",
  showSpinner = true,
  variant = "default"
}: LoadingProps) {
  if (variant === "dragonfly") {
    return (
      <div className={cn("flex flex-col items-center justify-center p-4", className)}>
        <DragonfliesLoader 
          size={size} 
          color={color} 
          showText={!!text} 
          text={text}
        />
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col items-center justify-center p-4", className)}>
      {showSpinner && (
        <Loader2
          className={cn(
            "animate-spin",
            {
              "h-6 w-6": size === "sm",
              "h-8 w-8": size === "md",
              "h-10 w-10": size === "lg"
            }
          )}
        />
      )}
      {text && <p className="mt-2 text-muted-foreground">{text}</p>}
    </div>
  );
}
